export const name = "ASIN";
export const summary = `Computes the inverse sine of \`X\`.`;
export const reference = `
## ASIN

Computes the inverse sine of \`X\`.

\`\`\`
ASIN(X)
\`\`\`

### Description

Computes the principal value of the inverse sine of X. The return value is in the range [-π/2,π/2]. Generates an error if X is outside of the range [-1, 1].

| X | ASIN(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| X \\< -1 | Error |
| X \\> 1 | Error |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
